import type { TOptional } from '@core/models/utility.model';
import type {
  TPermissionPropExtractor,
  TPermissionsUtil,
  TPermissionsUtilExtractor,
  TPermissionUtil,
  TPermissionUtilExtractor
} from '@shared/models/permissionService.model';

const combinePermissionsToEntity = <P extends readonly string[]>(
  permissions: P,
  permissionsSet: Set<P[number]>
) => {
  return permissions.reduce((acc, permission) => {
    const [first, second] = permission.split(':');
    const group = first as TOptional<TPermissionUtilExtractor<P>>;
    const action = second as TOptional<TPermissionPropExtractor<P[number], 'value'>>;

    if (group && action) {
      acc[group] ??= {} as TPermissionUtilExtractor<P, 'value'>;
      acc[group] = { ...acc[group], [action]: permissionsSet.has(permission) };
    }

    return acc;
  }, {} as TPermissionUtil<P>);
};

const combinePermissionsToArray = <P extends readonly string[]>(permissions: P) => {
  return permissions.reduce((acc, permission) => {
    const [first] = permission.split(':');
    const group = first as TOptional<TPermissionsUtilExtractor<P>>;

    if (group) {
      acc[group] ??= [] as unknown as TPermissionsUtilExtractor<P, 'value'>;
      acc[group] = [...acc[group], permission] as unknown as TPermissionsUtilExtractor<P, 'value'>;
    }

    return acc;
  }, {} as TPermissionsUtil<P>);
};

export { combinePermissionsToEntity, combinePermissionsToArray };
